var _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2026White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 236,
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 290,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 110,
    fontWeight: 800,
    fill: "#DC2626"
  }, "2026")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2026White);
export default __webpack_public_path__ + "static/media/2026-white.a50b7e1c3132e1dc80a8d630b5a4e2e0.svg";
export { ForwardRef as ReactComponent };